import type { ReactNode } from "react";
import CheckmarkBold from "svg/checkmark-bold.svg";
import { formatCurrency } from "helpers/currency";

type ProductCardProps = {
  name: string;
  price: number;
  color?: string;
  image?: string;
  selected?: boolean;
  includedInPlan?: boolean;
  hidePrice?: boolean;
  children?: ReactNode;
};

const ProductCard = ({
  name,
  price,
  color = "",
  image,
  selected = false,
  includedInPlan = false,
  hidePrice = false,
  children,
}: ProductCardProps) => {
  const priceLabel = includedInPlan
    ? "Included in your plan"
    : formatCurrency(price);

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="relative pt-4">
        {selected && (
          <div className="absolute left-1/2 top-0 z-10 -translate-x-1/2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-sage text-white shadow">
              <CheckmarkBold className="h-4 w-4" />
            </div>
          </div>
        )}
        <div
          className={`overflow-hidden rounded-xl border-2 bg-white ${
            selected ? "border-sage" : "border-oat-200"
          }`}
        >
          {image ? (
            <img
              src={image}
              alt={name}
              className="h-52 w-full object-contain"
            />
          ) : (
            <div
              className="h-52 w-full bg-gray-200"
              style={color ? { backgroundColor: color } : undefined}
            />
          )}
        </div>
      </div>
      <div className="flex flex-1 flex-col pt-3 text-center">
        <p className="font-serif text-2xl text-soil">{name}</p>
        {!hidePrice && (
          <p
            className={`text-sm ${includedInPlan ? "font-medium text-evergreen" : "text-evergreen"}`}
          >
            {priceLabel}
          </p>
        )}
        <div className="mt-auto pt-3">{children}</div>
      </div>
    </div>
  );
};

export default ProductCard;
